export default "__VITE_ASSET__tBUYVz6s__"